import { jsx } from "panel";
import { selx } from "clsx";
import { canUseViewN } from "common/components/data-table/utils";
import { SvgIconEl } from "common/components/svg-icon";
import { FlowsSankeyChartWidgetEl } from "common/report/flows/charts/flows-sankey-chart";
import { FlowsTopPathsChartWidgetEl } from "common/report/flows/charts/flows-top-paths-chart";
import { FunnelsFrequencyAggregateChartWidgetEl } from "common/report/funnels/charts/funnels-frequency-aggregate-widget";
import { FunnelsFrequencyDistributionChartWidgetEl } from "common/report/funnels/charts/funnels-frequency-distribution-widget";
import { FunnelsFrequencyLineChartEl } from "common/report/funnels/charts/funnels-frequency-line-chart";
import { FunnelsStepChartEl } from "common/report/funnels/charts/funnels-step-chart";
import { FunnelsStepsMetricWidgetEl } from "common/report/funnels/charts/funnels-steps-metric-widget";
import { FunnelsTopPathsChartEl } from "common/report/funnels/charts/funnels-top-path-chart";
import { FunnelsTrendsChartEl } from "common/report/funnels/charts/funnels-trends-chart";
import { FunnelsTtcAggregateMetricWidgetEl } from "common/report/funnels/charts/funnels-ttc-aggregate-metric-widget";
import { FunnelsTtcAggregateWidgetEl } from "common/report/funnels/charts/funnels-ttc-aggregate-widget";
import { FunnelsTimeToConvertDistributionChartWidgetEl } from "common/report/funnels/charts/funnels-ttc-distribution-widget";
import { FunnelsTTCLineChartEl } from "common/report/funnels/charts/funnels-ttc-line-chart";
import { InsightsBarChartEl } from "common/report/insights/charts/insights-bar-chart";
import { InsightsLineChartEl } from "common/report/insights/charts/insights-line-chart";
import { InsightsMetricChartEl } from "common/report/insights/charts/insights-metric-chart";
import { InsightsPieChartEl } from "common/report/insights/charts/insights-pie-chart";
import { InsightsTableChartEl } from "common/report/insights/charts/insights-table-chart";
import { RetentionCurveChartEl } from "common/report/retention/charts/retention-curve-chart";
import { RetentionTrendsChartEl } from "common/report/retention/charts/retention-trends-chart";
import { RetentionTrendsMetricChartEl } from "common/report/retention/charts/retention-trends-metric-chart";
import styles from "./index.module.styl";
const CardHeader = ({ cmp }) => {
  return /* @__PURE__ */ jsx("div", {
    key: "card-header",
    sel: selx(styles.cardHeader)
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: selx([styles.cardTitle, `.bold`]),
    attrs: { title: cmp.params.cardTitle }
  }, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.nameContainer)
  }, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.sideIcon)
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-insights` }
  })), /* @__PURE__ */ jsx("p", null, cmp.params.cardTitle)))));
};
const CardChart = ({ cmp }) => {
  const { chartParams } = cmp.params;
  const chartType = cmp.params.chartOptions.type;
  return /* @__PURE__ */ jsx("div", {
    sel: selx(styles.cardChart),
    style: {
      overflow: chartType === cmp.ChartType.Line || chartType === cmp.ChartType.StackedLine ? `hidden` : `auto`
    }
  }, !cmp.params.reportLoading ? chartType === cmp.ChartType.RetentionTrendMetric ? /* @__PURE__ */ jsx("div", {
    sel: ".common-metric-container"
  }, /* @__PURE__ */ jsx(RetentionTrendsMetricChartEl, {
    params: cmp.getParamsForRetentionMetricChart()
  })) : chartType === cmp.ChartType.Metric ? /* @__PURE__ */ jsx("div", {
    sel: ".common-metric-container"
  }, /* @__PURE__ */ jsx(InsightsMetricChartEl, {
    props: {
      paramsAndResults: {
        params: cmp.getBookmarkParamsWithDashboardOverrides(),
        results: chartParams
      },
      dataGroups: cmp.getDataGroups()
    }
  })) : chartType === cmp.ChartType.FunnelSteps ? /* @__PURE__ */ jsx(FunnelsStepChartEl, {
    attrs: { loaded: true },
    props: cmp.getFunnelStepsChartWidgetProps()
  }) : chartType === cmp.ChartType.FunnelTrend ? /* @__PURE__ */ jsx(FunnelsTrendsChartEl, {
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : chartType === cmp.ChartType.FunnelTopPaths ? /* @__PURE__ */ jsx(FunnelsTopPathsChartEl, {
    attrs: { "disable-click-node": true },
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : chartType === cmp.ChartType.FunnelMedianTTC ? /* @__PURE__ */ jsx("div", {
    sel: ".common-metric-container"
  }, /* @__PURE__ */ jsx(FunnelsTtcAggregateMetricWidgetEl, {
    attrs: cmp.getFunnelTTCBarChartAttributes(),
    props: cmp.getFunnelCommonChartWidgetProps()
  })) : chartType === cmp.ChartType.FunnelStepsMetric ? /* @__PURE__ */ jsx("div", {
    sel: ".common-metric-container"
  }, /* @__PURE__ */ jsx(FunnelsStepsMetricWidgetEl, {
    props: cmp.getFunnelCommonChartWidgetProps()
  })) : chartType === cmp.ChartType.FunnelTTCLine ? /* @__PURE__ */ jsx(FunnelsTTCLineChartEl, {
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : chartType === cmp.ChartType.FunnelTTCBar ? cmp.isFunnelAggregateChart(chartType) ? /* @__PURE__ */ jsx(FunnelsTtcAggregateWidgetEl, {
    attrs: cmp.getFunnelTTCBarChartAttributes(),
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : /* @__PURE__ */ jsx(FunnelsTimeToConvertDistributionChartWidgetEl, {
    attrs: cmp.getFunnelTTCBarChartAttributes(),
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : chartType === cmp.ChartType.FunnelFrequencyLine ? /* @__PURE__ */ jsx(FunnelsFrequencyLineChartEl, {
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : chartType === cmp.ChartType.FunnelFrequencyBar ? cmp.isFunnelAggregateChart(chartType) ? /* @__PURE__ */ jsx(FunnelsFrequencyAggregateChartWidgetEl, {
    attrs: cmp.getFunnelFrequencyBarChartAttributes(),
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : /* @__PURE__ */ jsx(FunnelsFrequencyDistributionChartWidgetEl, {
    attrs: cmp.getFunnelFrequencyBarChartAttributes(),
    props: cmp.getFunnelCommonChartWidgetProps()
  }) : chartType === cmp.ChartType.Sankey ? /* @__PURE__ */ jsx(FlowsSankeyChartWidgetEl, {
    attrs: cmp.getFlowSankeyChartAttributes(),
    props: cmp.getFlowsChartWidgetProps()
  }) : chartType === cmp.ChartType.FlowsTopPaths ? /* @__PURE__ */ jsx(FlowsTopPathsChartWidgetEl, {
    attrs: { loaded: true },
    props: cmp.getFlowsChartWidgetProps()
  }) : chartType === cmp.ChartType.Line || chartType === cmp.ChartType.StackedLine ? /* @__PURE__ */ jsx(InsightsLineChartEl, {
    sel: ".line-chart",
    attrs: {
      loaded: true,
      timezone: cmp.params.projectTimezone,
      "utc-offset": cmp.params.utcOffset
    },
    props: {
      paramsAndResults: {
        params: cmp.getBookmarkParamsWithDashboardOverrides(),
        results: chartParams
      },
      dataGroups: cmp.getDataGroups()
    }
  }) : chartType === cmp.ChartType.StackedBar || chartType === cmp.ChartType.Bar ? /* @__PURE__ */ jsx(InsightsBarChartEl, {
    props: {
      paramsAndResults: {
        params: cmp.getBookmarkParamsWithDashboardOverrides(),
        results: chartParams
      },
      dataGroups: cmp.getDataGroups()
    }
  }) : chartType === cmp.ChartType.Pie ? /* @__PURE__ */ jsx(InsightsPieChartEl, {
    sel: ".pie-chart",
    attrs: {
      loaded: true
    },
    props: {
      paramsAndResults: {
        params: cmp.getBookmarkParamsWithDashboardOverrides(),
        results: chartParams
      },
      dataGroups: cmp.getDataGroups()
    }
  }) : chartType === cmp.ChartType.Table ? /* @__PURE__ */ jsx(InsightsTableChartEl, {
    params: {
      bookmarkParams: cmp.getBookmarkParamsWithDashboardOverrides(),
      results: chartParams,
      dataGroups: cmp.getDataGroups(),
      startScrolledRight: true,
      enablePivotView: false,
      canUseViewN: canUseViewN(null)
    }
  }) : chartType === cmp.ChartType.RetentionLine || cmp.ChartType.RetentionCurve ? /* @__PURE__ */ jsx(RetentionCurveChartEl, {
    attrs: cmp.getAttributesForRetentionCurveChart(),
    props: cmp.getPropsForRetentionCurveChart()
  }) : chartType === cmp.ChartType.RetentionTrend ? /* @__PURE__ */ jsx(RetentionTrendsChartEl, {
    attrs: cmp.getAttributesForRetentionTrendsChart(),
    props: cmp.getPropsForRetentionTrendsChart()
  }) : null : null);
};
const ReportCard = ({ cmp }) => {
  return /* @__PURE__ */ jsx("div", {
    sel: selx(styles.cardRoot)
  }, /* @__PURE__ */ jsx(CardHeader, {
    cmp
  }), /* @__PURE__ */ jsx("div", {
    sel: selx(styles.cardReport)
  }, /* @__PURE__ */ jsx(CardChart, {
    cmp
  })));
};
export function template() {
  return /* @__PURE__ */ jsx(ReportCard, {
    cmp: this
  });
}
